$(document).ready(function(){
    const forms = $('.needs-validation');

    forms.submit( function(event){
        var form = $( this );

        event.preventDefault();
        event.stopPropagation();

        if ( ! form[0].checkValidity() ) {
            event.preventDefault();
            event.stopPropagation();
        }

        form.addClass('was-validated');
    } );
});
